document.addEventListener(
	"DOMContentLoaded",
	function () {
		jQuery(
			function ($) {
				$( ".forum-filters__list--item__btn" ).on(
					"click",
					function (e) {
						e.preventDefault();
						var $this  = $( this );
						var values = [];

						if ($this.hasClass( "forum-filters__list--item__btn--active" )) {
							$this.removeClass( "forum-filters__list--item__btn--active" );
						} else {
							$this.addClass( "forum-filters__list--item__btn--active" );
						}

						var active = document.querySelectorAll(
							".forum-filters__list--item__btn--active"
						);

						// Loop over the NodeList (returned by querySelectorAll)
						active.forEach(
							function (element) {
								// Push the data-id attribute of each element into the array
								if ( ! isNaN( element.getAttribute( "data-id" ) )) {
									values.push( element.getAttribute( "data-id" ) );
								}
							}
						);

						$.ajax(
							{
								type: "POST",
								url: "/wp-admin/admin-ajax.php",
								dataType: "html",
								data: {
									action: "nen_forum_filtering",
									nonce: $( "#_wpnonce_forum_filter" ).val(),
									forum: $this.data( "forum" ),
									topic: values.join( "," ),
								},
								beforeSend: function () {
									console.log( "loading" );
									$( ".bs-item-list" ).addClass( "nen-loading" );
								},
								success: function (res) {
									$( ".bs-item-list li:not(.bs-item-wrap)" ).remove();
									$( ".bs-item-list" ).append( res );
									if (values.length <= 0) {
										$( ".bbp-pagination" ).show();
									} else if (values.length >= 1) {
										$( ".bbp-pagination" ).hide();
									}
									$( ".bs-item-list" ).removeClass( "nen-loading" );
									// $( "#signupWrapper" ).html( res );
								},
							}
						);
					}
				);
			}
		);
	}
);
